import { useEffect } from 'react'
import { SettingsState } from '@/types/settings'

interface KeyboardShortcutsHandlers {
  onExport: () => void
  onResetAll: () => void
  onClose: () => void
}

export const useKeyboardShortcuts = (
  isOpen: boolean,
  settings: SettingsState,
  handlers: KeyboardShortcutsHandlers
) => {
  useEffect(() => {
    if (!isOpen || !settings.keyboardShortcuts) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey) {
        switch (e.key) {
          case 's':
            e.preventDefault()
            handlers.onExport()
            break
          case 'r':
            e.preventDefault()
            handlers.onResetAll()
            break
          case 'Escape':
            handlers.onClose()
            break
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, settings.keyboardShortcuts, handlers])
}